const ModalCard: React.FC<{ children: React.ReactNode[] | React.ReactNode }> = ({ children }) => {
    return (
        <div className="w-[420px] flex flex-col gap-5 bg-white p-5 rounded">
            {children}
        </div>
    )
}

export default ModalCard